import { Video } from "@/models/video.entity";
import videoService from "@/services/mrfiktiv/services/video.service";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { FetchStrategy, SharedContentDocument, safeFetch } from "../SharedContentFetchStrategy";

export class VideoFetchStrategy implements FetchStrategy {
  canHandle(refType: string): boolean {
    return refType === ResourceEnum.VIDEO;
  }

  fetch(partnerId: string, refId: string, sct: string): Promise<SharedContentDocument> {
    return safeFetch(refId, ResourceEnum.VIDEO, async () => {
      return await videoService
        .getOneShared({
          partnerId: partnerId,
          sct: sct,
          videoId: refId
        })
        .then(v => new Video(v));
    });
  }
}
